import { RiskScaleItem, RiskScales } from "@/features/risks/entities/risk/model/risk.types"

export function sortScales(scales: RiskScales): RiskScales {
  return {
    ...scales,
    severityScale: [...scales.severityScale].sort((a: RiskScaleItem, b: RiskScaleItem) => a.value - b.value),
    frequencyScale: [...scales.frequencyScale].sort((a: RiskScaleItem, b: RiskScaleItem) => a.value - b.value),
    preventionScale: [...scales.preventionScale].sort((a: RiskScaleItem, b: RiskScaleItem) => a.value - b.value),
    residualRiskScale: scales.residualRiskScale
  }
}

export function sortScaleItems(items: RiskScaleItem[]): RiskScaleItem[] {
  return [...items].sort((a, b) => a.value - b.value)
}
